import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "m15.401 11.129-5.288-4.594c-.346-.3-.819-.369-1.235-.179s-.675.592-.675 1.05v9.188A1.162 1.162 0 0 0 9.36 17.75c.271 0 .537-.097.753-.285l5.288-4.594a1.155 1.155 0 0 0 0-1.742z"
}), 'ArrowRight');